import React from 'react';
import PropTypes from 'prop-types'; // eslint-disable-line import/no-extraneous-dependencies

const Search = ({ value, onSearch }) => (
  <div className="search-item">
    <input
      type="text"
      value={value}
      onChange={onSearch}
      placeholder="Search"
      className="search-field"
    />
    <i className="search-icon" />
  </div>
);

Search.propTypes = {
  value: PropTypes.string,
  onSearch: PropTypes.func,
};

Search.defaultProps = {
  value: '',
  onSearch: () => { },
};

export default Search;
